/*
 * Public API Surface of kraken-icon-menu
 */

export * from './lib/kraken-icon-menu.service';
export * from './lib/kraken-icon-menu.component';
export * from './lib/kraken-icon-menu.module';
